import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { TestAudiencesByIds, TestAudiencesByIdsVariables } from './__generated__/TestAudiencesByIds';

export const TEST_AUDIENCES_BY_IDS = gql`
  query TestAudiencesByIds($articleId: ID!, $audienceIds: [Int!]!) {
    testAudiencesByIds(articleId: $articleId, audienceIds: $audienceIds) {
      audienceSizeDescription
      errors
    }
  }
`;

export const useTestAudiencesByIdsQuery = () => {
  return useLazyQuery<TestAudiencesByIds, TestAudiencesByIdsVariables>(TEST_AUDIENCES_BY_IDS, {
    client: kmsClient,
    fetchPolicy: 'no-cache'
  });
};
